import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "../css/CollectionColorSettingView.module.css";
import { IconColor } from "../../common/model/IconColor";
import ListSettingView from "../../common/ListSettingView";
import { ReactComponent as ColorBoxIcon } from "../../../img/iconImgAllColorBox.svg";

interface CollectionColorSettingViewProps {
  open: boolean;
  item: IconColor;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function CollectionColorSettingView(
  props: CollectionColorSettingViewProps
) {
  const { t } = useTranslation();

  if (!props.open) return null;

  return (
    <>
      <div className={classNames(styles.container)}>
        <span className={styles.titleText}>{t("Colors")}</span>
        <div className={styles.settingViewContainer}>
          <ListSettingView
            title={props.item.name}
            valueStyle="stringValue"
            leftIcon={ColorBoxIcon}
            leftIconColor={props.item.color}
            handleOnClick={props.onClick}
          />
        </div>
      </div>
    </>
  );
}
